import styled from 'styled-components';

const Label = styled.label<{ capitalize?: boolean }>`
  ${({ theme }) => theme.fontSize.M16}
  display: block;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${({ capitalize }) => capitalize && 'text-transform: capitalize;'}
`;

export { Label };
